import { bookingInquiryApis } from '@apis/bookingInquiryApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useBookingInquiryDraft = createUseQuery(
  ['/booking-inquiry-draft/'],
  () => () => bookingInquiryApis.get('/booking-inquiry-draft/', {}).then((r) => r[200] ?? null),
);
